import React from "react";

function OtherGameItem({ href, children }) {
  return (
    <a
      href={href}
      className="bg-[#202020] text-[#F9F9F9] py-2 rounded-full hover:bg-[#3e3e3e] transition-colors w-[219px] text-center text-base font-barlow font-bold antialiased"
    >{children}</a>
  );
}

function OtherGamesList() {
  return (
    <div className="flex flex-col place-content-center">
      <p className="text-base mb-6 text-center">Jogue agora:</p>
      <div className="flex flex-col md:flex-row gap-3 place-content-center items-center">
        <OtherGameItem href="/cata-letras/">Jogar Cata-Letras</OtherGameItem>
        <OtherGameItem href="/jogos-caca-palavras/">Jogar Caça-Palavras</OtherGameItem>
      </div>
    </div>
  );
}

export default OtherGamesList;
